/**
 * FALLBACK ONLY — the cycle year when the server's config document is unavailable.
 *
 * The authoritative value is `OasisConfigService.cycleYear()`, served by
 * `GET /oasis-config`. Everything in the app should go through that; this exists so a
 * failed config fetch degrades to the app's previous behaviour rather than leaving an
 * applicant with no cycle year and therefore no dashboard.
 *
 * Rule: the recruitment cycle for year N runs roughly July of year N-1 through the
 * following spring, so from July onward the "current" cycle is next calendar year.
 * That is a guess about the calendar, which is exactly why it is not authoritative.
 */
export const getCurrentCycleYear = (now: Date = new Date()): number => {
	const year = now.getFullYear();
	// Months are 0-indexed; July === 6.
	return now.getMonth() >= 6 ? year + 1 : year;
};
